import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import { deleteCategory, fetchCategoryList } from "../actions/category";
import { useSelector } from "react-redux";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { useTranslation } from "react-i18next";
import AggridTable from "../components/Admin/Reusable/AggridTable";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { toast } from "react-toastify";
import { statusRender } from "../utils/cellRenderTable";
import { createDateColumn } from "../utils/agGridDateColumn";

const CategoryList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { categoryList } = useSelector((state) => state.categoryReducer);

  //breadcrumb
  const translateModule = "category";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchCategoryList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id || !params.data.name) return null;
    return (
      <ButtonColumn
        editLink={`/category-edit/` + params.data.id}
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.name}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(deleteCategory(pageId));
  };

  const columnDefs = [
    {
      headerName: "Naziv kategorije",
      field: "name",
      filter: "agTextColumnFilter",
      flex: 1,
    },
    {
      headerName: "Aktivan",
      field: "active",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      maxWidth: 140,
      valueGetter: (params) => {
        if (params.data?.active === true) return "Aktivan";
        if (params.data?.active === false) return "Neaktivan";
        return "";
      },
    },
    createDateColumn("Datum kreiranja", "createdAt"),
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 90,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={`${translateModule}${pageType}`}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        reloadData={() =>
          dispatch(fetchCategoryList()).then(() => {
            toast.success("Podaci su uspešno osveženi", {
              theme: "colored",
            });
          })
        }
        rowData={categoryList}
        columnDefs={columnDefs}
        buttonLink={`/category-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey="category-list"
      />
    </Fragment>
  );
};

export default CategoryList;
